import { useDispatch, useSelector } from "react-redux";
import { selectProductOutfitAvailability } from "../selectors/outfit";
import { setPDPOutfitAvailable } from "../store/actions/pdp-actions";

export function useProductOutfitAvailability() {
  const dispatch = useDispatch();
  const value = useSelector(selectProductOutfitAvailability);
  const setter = (productKey, isAvailable) =>
    dispatch(setPDPOutfitAvailable(productKey, isAvailable));
  return [value, setter];
}
